// components/NotificationProvider.tsx
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import 'animate.css';

const NotificationProvider = () => {
    return <ReactNotifications />;
};

export default NotificationProvider;
